@if (team().managers.length) {
  <button
    mat-button
    color="primary"
    class="team-name"
    [class.team-name-vertical]="!isVisible()"
    (click)="toggleVisibility()"
  >
    <span>
      Команда {{ team().reviewerName }}
    </span>
    @if (isVisible()) {
      <span class="team-plan">
        План мес. {{ formatBudgetValue(team().plannedMonthPrice) }} / день {{ formatBudgetValue(team().plannedDayPrice) }}
      </span>
    }
  </button>
  @if (isVisible()) {
    <div
      class="team-content"
      @smoothShowHideWidth
    >
      @if (team().teamExpenses) {
        <div class="team-expenses">
          <app-release-calendar-team-expenses
            [releaseCalendarTeamExpenses]="team().teamExpenses"
            [releaseCalendarSelectedOptions]="releaseCalendarSelectedOptions()"
          />
        </div>
      }
      @for (manager of team().managers; track $index) {
        <div class="managers">
          <app-release-calendar-manager
            [releaseCalendarManager]="manager"
            [releaseCalendarSelectedOptions]="releaseCalendarSelectedOptions()"
            [releaseCalendarTeamExpenses]="team().teamExpenses"
            [managerIndex]="$index"
          />
        </div>
      }
    </div>
  }
}
